import { erpAxios } from '..';

const editKomitentDatumRodjenja = async (data) => {
  const res = await erpAxios.post(`/komitenti/editDatumRodjenja`, data);
  return res;
};

export default editKomitentDatumRodjenja;
